"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SourceHoverButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _SourceHoverButton = require("./SourceHoverButton.styled");
var _ = require("../..");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _useTranslate2 = require("../../locales/useTranslate");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SourceHoverButton = exports.SourceHoverButton = function SourceHoverButton(_ref) {
  var source = _ref.source,
    onTogglePlay = _ref.onTogglePlay,
    onSetSourceLive = _ref.onSetSourceLive,
    layout = _ref.layout;
  var sourceId = source._id,
    type = source.type;
  var iconShouldBeActive = layout === _.SINGLE.id;
  var targetElementId = "program-solo-icon-".concat(sourceId);
  var _useTranslate = (0, _useTranslate2.useTranslate)(),
    translate = _useTranslate.translate;
  var toolTipText = translate('Source_Spotlight_Popover');
  var onClick = function onClick() {
    var PLAY = 'play';
    onSetSourceLive(source);
    if ([_.VIDEO_FILE, _.AUDIO_FILE].includes(type)) {
      onTogglePlay(sourceId, PLAY);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_SourceHoverButton.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_SourceHoverButton.StyledButton, {
    "data-testid": "program-solo-button-".concat(sourceId),
    onClick: onClick,
    isActive: iconShouldBeActive
  }, /*#__PURE__*/_react["default"].createElement(_SourceHoverButton.StyledSoloIcon, {
    id: targetElementId,
    icon: _freeSolidSvgIcons.faMaximize,
    isActive: iconShouldBeActive
  })), /*#__PURE__*/_react["default"].createElement(_.ToolTip, {
    targetElement: targetElementId,
    message: toolTipText,
    placement: "bottom",
    noPointerEvent: true
  }));
};
SourceHoverButton.propTypes = {
  source: _propTypes.object,
  onTogglePlay: _propTypes["default"].func.isRequired,
  onSetSourceLive: _propTypes["default"].func.isRequired,
  layout: _propTypes["default"].string
};